import React from "react";
import PropTypes from "prop-types";
  
export default function BtnLoader({
  btnLaoder = false
  }) {  
  	return (
     <div className="buttonloader"><div className={`loader_wrap ${ btnLaoder ? 'loader_active' : '' }`}><div className="preload"></div> </div></div>
    );
}